/**
 * IMPORTS
 */
import {ApplicationError} from 'src/aggregates/err/applicationerror';


/**
 * CODE
 */

/**
 * I am a contact already exists error.
 */
class ContactAlreadyExistsError extends ApplicationError
{
    // add props
    channel: string;
    customerId: string | number;
    customerName: string;
    uid: string;

    /**
     * I initialize myself.
     *
     * :param channel: contact channel
     * :param customerId: customer id
     * :param customerName: customer name
     * :param uid: contact uid
     *
     * :returns: nothing
     */
    constructor (
        channel: string,
        customerId: string | number,
        customerName: string,
        uid: string,
    )
    {
        // call the superclass constructor
        super(`Contact ${channel}/${uid} already exists at customer ` +
             `${customerId}/${customerName}`);

        // set props
        this.channel = channel;
        this.customerId = customerId;
        this.customerName = customerName;
        this.uid = uid;
    }
}


/**
 * EXPORTS
 */
export {
    ContactAlreadyExistsError,
};
